import { Component, Host, Prop, h } from '@stencil/core';

import { trackMoreInfoClick } from '../../../tracking/tracking.dealer';

@Component({
  tag: 'google-map-info-window',
  styleUrl: 'google-map-info-window.css',
})
export class GoogleMapInfoWindow {
  @Prop() address: string = '';
  @Prop() dealerName: string = '';
  @Prop() dealershipCity: string = '';
  @Prop() dealershipState: string = '';
  @Prop() dealershipZipCode: string = '';
  @Prop() distance: number = 0;
  @Prop() index: number = 0;
  @Prop() specChosen: string = '';
  @Prop() whenClicked: (index: number) => void = () => {};

  onMoreInfoClick = (e) => {
    trackMoreInfoClick(this.index);
    e.preventDefault();
    this.whenClicked(this.index);
  };

  render() {
    return (
      <Host>
        <div class="max-w-xs">
          <h3>{this.dealerName}</h3>
          <div class="mt-1">{this.address}</div>
          <div>
            <span>
              {this.dealershipCity}, {this.dealershipState} {this.dealershipZipCode}
            </span>
          </div>
          <div class="flex flex-row mt-1">
            <div class="flex-1 mr-10">{this.distance} Miles away</div>
            <ico-hyperlink href={`#dealer-${this.index + 1}`} onClick={this.onMoreInfoClick}>
              More Info
            </ico-hyperlink>
          </div>
          {this.specChosen && (
            <div class="bg-clrs-light-green w-100 rounded p-1 mt-2 text-clrs-green">
              <strong>{this.specChosen}</strong>
            </div>
          )}
        </div>
      </Host>
    );
  }
}
